export default {
    abs: "абс.",
    activate: "Активдештирүү",
    add_category: "Категорияны кошуу",
    add_kit: "Комплект кошуу",
    additional_materials: "Кошумча материалдар",
    archive: "Архив",
    are_you_sure_you_want_to_delete_category: "Сиз чындыгында категорияны жок кылгыңыз келеби?",
    are_you_sure_you_want_to_delete_service: "Сиз чындыгында категорияны жок кылгыңыз келеби?",
    assistant_reward: "Жардамчынын сыйлыгы",
    average_price: "Орточо баа",
    categories: "Категориялар",
    category: "Категория",
    change_category: "Категорияны өзгөртүү",
    change_pricelist: "Прайсты өзгөртүү",
    classificator_code: "Классификатор боюнча код",
    classificator_title: "Классификатор боюнча аталыш",
    complex_service: "Комплекстик кызмат",
    complex_services: "Комплекстик кызматтар",
    curator_reward: "Куратордун сыйлыгы",
    current_value: "Учурдагы баа",
    deactivate: "Деактивдештирүү",
    decrease_price: "Бааны төмөндөтүү",
    discounted_price: "Арзандатылган баа",
    do_not_accrue_bonus: "Бонусту эсептебөө",
    doctor_reward: "Дарыгердин сыйлыгы",
    fill_from_previous_visits: "Мурунку сапарлардан толтуруңуз",
    fixed_materials_expense_sum: "Белгиленген материалдык чыгымдын суммасы",
    import_standard_services: "Стандарттык кызмат көрсөтүүлөрдү импорттоо",
    increase_price: "Бааны көбөйтүү",
    individual_bonus: "Бейтап үчүн жеке бонус (%)",
    make_separate: "Аны өзүнчө кыл",
    manager: "Администратор",
    manager_reward: "Администратордун сыйлыгы",
    mkb_10_diagnosis: "ICD 10 боюнча диагноз",
    money_lost_on_discount: "Арзандатуулардан акча жоготуу",
    move_to_group: "Топко жылдыруу",
    ndfl_code: "ЖКС коду ",
    not_selected: "Белгиленген эмес",
    packages_cost: "Топтомдордун баасы",
    personal_percent_for_assistant: "Жардамчы үчүн жеке пайыз",
    personal_percent_for_curator: "Куратор үчүн жеке пайыз",
    personal_percent_for_doctor: "Дарыгер үчүн жеке пайыз",
    personal_percent_for_manager: "Администратор үчүн жеке пайыз",
    personal_percent_for_technic: "Техник үчүн жеке пайыз",
    price_can_be_changed: "Дарылоо карточкасындагы баа өзгөрүшү мүмкүн",
    price_from: "Баасы   баштап",
    pricelist_price: "Прайс боюнча баасы",
    pricelist_short: "Прайс",
    reset_selection: "Тандоону өзгөртүү",
    send_to_archive: "Архивке жөнөтүү",
    Service: "Кызмат",
    service_category: "Категория",
    service_code: "Кызмат коду",
    services_not_selected: "Кызмат тандалган жок",
    technic: "Техник",
    technic_reward: "Техниктин сыйлыгы",
    teeth_not_selected: "Тиш тандалган жок",
    use_visit_anamnez: "Сапар тарыхын колдонуңуз",
    visit_status: "Статусуна баруу"
}
